import { render, staticRenderFns } from "./NvDiscover.vue?vue&type=template&id=9d44b760&scoped=true&"
import script from "./NvDiscover.vue?vue&type=script&lang=js&"
export * from "./NvDiscover.vue?vue&type=script&lang=js&"
import style0 from "./NvDiscover.vue?vue&type=style&index=0&id=9d44b760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d44b760",
  null
  
)

export default component.exports